export const categoryInfo = [
    {
        typeId: 1,
        type: "Donations",
        hasOptions: false
    },
    {
        typeId: 2,
        type: "Conference Registration",
        hasOptions: true,
        options: [
            {
                name: "19th IUMRS-ICAM, ACCRA-GHANA 2025",
                link: "https://paystack.com/pay/iumrs-icam_registration"
            },
            {
                name: "KPMG Sustainability Conference",
                link: "https://paystack.com/pay/amrs_fees"
            }
        ]
    },
    {
        typeId: 3,
        type: "Fee payment",
        hasOptions: true,
        options: [
            {
                name: "Gold Fields Tarkwa field trip",
                link: "https://paystack.com/pay/amrs_fees"
            },
            {
                name: "AMRS-Robotics Workshop",
                link: "https://paystack.com/pay/amrs_fees"
            }
        ]
    }
];